/**
 * Feedback Store
 * Stores like/dislike actions for chat messages
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type FeedbackType = 'like' | 'dislike' | null;

interface FeedbackStore {
  feedbacks: Record<string, FeedbackType>; // messageId -> feedback type
  setFeedback: (messageId: string, feedback: FeedbackType) => void;
  getFeedback: (messageId: string) => FeedbackType;
  clearFeedback: (messageId: string) => void;
  clearAllFeedbacks: () => void;
}

export const useFeedbackStore = create<FeedbackStore>()(
  persist(
    (set, get) => ({
      feedbacks: {},

      setFeedback: (messageId, feedback) =>
        set(
          (state): FeedbackStore => ({
            ...state,
            feedbacks: {
              ...state.feedbacks,
              [messageId]: feedback,
            },
          })
        ),

      getFeedback: messageId => {
        const state = get();
        return state.feedbacks[messageId] || null;
      },

      clearFeedback: messageId =>
        set((state): FeedbackStore => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { [messageId]: _unused, ...rest } = state.feedbacks;
          return {
            ...state,
            feedbacks: rest,
          };
        }),

      clearAllFeedbacks: () =>
        set(
          (state): FeedbackStore => ({
            ...state,
            feedbacks: {},
          })
        ),
    }),
    {
      name: 'feedback-store',
      partialize: state => ({
        feedbacks: state.feedbacks,
      }),
    }
  )
);
